import EventBus from './event-bus'

class AnalyticsManager {
    constructor() {
        this._bus = EventBus;
        this._listeners = {
            gtag: null,
            fbq: null
        };
        this._stacks = {
            gtag: [],
            fbq: []
        };
        this._data = {};
    }


    bootstrap() {
        this._data = this._extractData();
        this._checkIfPresent('gtag', true);
        this._checkIfPresent('fbq', true);

        this._bus.on('analytics-manager.push', (...payload) => this.send(...payload));

        return this;
    }


    send(dataId) {
        if (typeof this._data[dataId] === 'undefined') {
            return;
        }

        this._pushFbq(this._data[dataId]);
        this._pushGtag(this._data[dataId]);
    }

    _pushFbq(data) {
        if (!this._listeners.fbq) {
            this._stacks.fbq.push(data);
            return this;
        }

        let payload = {};

        payload[data.category] = data.label;
        this._listeners.fbq('trackCustom', data.action, payload);

        return this;
    }


    _pushGtag(data) {
        if (!this._listeners.gtag) {
            this._stacks.gtag.push(data);
            return this;
        }
        let payload = {
            event_category: data.category,
            event_label: data.label
        };

        if (data.value !== undefined && data.value !== null) {
            payload.value = data.value;
        }

        this._listeners.gtag('event', data.action, payload);

        return this;
    }


    _checkIfPresent(listener, recheck = false, delay = 500) {
        if (typeof this._listeners[listener] === 'undefined') {
            return this;
        }

        if (typeof window[listener] === 'function') {
            this._listeners[listener] = window[listener];

            while (this._stacks[listener].length) {
                this.send(this._stacks[listener].shift());
            }
        } else if (recheck) {
            this._delayedCheckIfPresent(listener, 500);
        }

        return this;
    }


    _delayedCheckIfPresent(listener, delay = 500) {
        window.setTimeout(() => {
            this._checkIfPresent(listener, true, delay * 2);
        }, delay);
    }

    _extractData() {
        try {
            return JSON.parse(
                document.querySelector('script[type="application/json"][id="analytics-data"]').textContent
            );
        } catch (e) {
            return {};
        }
    }
}

EventBus.on('filter-selected.checkbox', (element) => {
    const dataId = element.dataset.analyticsId;

    if (!dataId) {
        console.warn('Undefined element data id', element);
        return;
    }

    if (element.checked) {
        return EventBus.emit('analytics-manager.push', dataId);
    }
});

EventBus.on('filter-selected.select', (element) => {
    try {
        const option = Array.from(element.options).find(option => option.value.toString() === element.value.toString());
        const dataId = option.dataset.analyticsId;

        if (!dataId) {
            console.warn('Undefined element data id', element, option);
            return;
        }

        EventBus.emit('analytics-manager.push', dataId);
    } catch (e) {
    }
});

EventBus.on('filters-expanded', (element) => setTimeout(() => {
    try {
        const isOpen = element.classList.contains('open');
        const dataId = element.dataset.analyticsId;

        if (!dataId) {
            console.warn('Undefined element data id', element);
            return;
        }

        if (isOpen) {
            EventBus.emit('analytics-manager.push', dataId);
        }
    } catch (e) {
    }
}, 1000));

window.addEventListener('load', () => {
    const manager = new AnalyticsManager;

    manager.bootstrap();
});
